<template>
  <div class="risk">
    <img class="risk-graph" src="../../assets/risk/meter2.svg" />
    <img class="risk-pointer" src="../../assets/risk/pointer4.svg"
    :style="{ transform: `translate(-50%, -50%) rotate(${scoreDegree}deg)` }" />
    <div class="risk-score" v-if="showDetail">
      <div class="risk-number">
        {{Math.min(scoreInteger, 99)}}%
      </div>
      Haalbaarheid
      <div style="color: rgba(0, 0, 0, .3); margin-top: 5%;" v-if="showNotice">
        <template v-if="scoreInteger >= 0 && scoreInteger < 5">
          Uw haalbaarheid is heel erg laag.
          U kunt uw inleg verhogen of langer beleggen om uw haalbaarheid te verhogen
        </template>
        <template v-if="scoreInteger >= 5 && scoreInteger < 20">
          Uw haalbaarheid is erg laag.
          U kunt uw inleg verhogen of langer beleggen om uw haalbaarheid te verhogen.
        </template>
        <template v-if="scoreInteger >= 20 && scoreInteger < 40">
          Uw haalbaarheid is laag.
          U kunt uw inleg verhogen of langer beleggen om uw haalbaarheid te verhogen.
        </template>
        <template v-if="scoreInteger >= 40 && scoreInteger < 50">
          Uw haalbaarheid is iets te laag.
          U kunt uw inleg verhogen of langer beleggen om uw haalbaarheid te verhogen.
        </template>
        <template v-if="scoreInteger >= 50 && scoreInteger < 60">
          Uw haalbaarheid is prima.
          U kunt uw inleg verhogen of langer beleggen om uw haalbaarheid te verhogen.
        </template>
        <template v-if="scoreInteger >= 60 && scoreInteger < 80">
          Uw haalbaarheid is goed. U heeft zelfs een buffer voor mindere tijden.
        </template>
        <template v-if="scoreInteger >= 80 && scoreInteger < 99">
          Uw haalbaarheid is uitstekend. U kunt uw doelvermogen zelfs wat verhogen.
        </template>
        <template v-if="scoreInteger >= 99 && scoreInteger < 100">
          Uw haalbaarheid is hoog. U kunt uw doelvermogen verhogen.
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ScoreWidget',
  emits: ['update:model-value'],
  props: {
    modelValue: Number,
    showDetail: {
      default: true,
      type: Boolean,
    },
    showNotice: {
      default: true,
      type: Boolean,
    },
  },
  computed: {
    scoreDegree() {
      return this.formatPrice((Number(this.modelValue - 50) * 2.4), false, 0);
    },
    scoreInteger() {
      return this.formatPrice((Number(this.modelValue)), false, 0);
    },
  },
};
</script>

<style lang="scss" scoped>
  .risk {
    width: 100%;
    padding: 5%;
    padding-top: 100%;
    box-sizing: border-box;
    // background-color: #f7f8fa;
    position: relative;
    color: #000066;
    .risk-graph {
      width: 90%;
      position: absolute;
      top: 40%;
      transform: translateY(-50%);
    }
    .risk-pointer {
      position: absolute;
      top: 35%;
      left: 50%;
      width: 45%;
      height: 45%;
      transition: transform .3s linear;
      transform-origin: center 89%;
    }
    .risk-score {
      position: absolute;
      top: 65%;
      left: 50%;
      transform: translateX(-50%);
      text-align: center;
      width: 100%;
      .risk-number {
        font-weight: 600;
        margin-bottom: 10px;
        font-size: 24px;
      }
    }
  }
</style>
